//src/hooks/useOnClickOutside.js
import { useEffect } from 'react';

/**
 * Hook để xử lý việc click chuột ra bên ngoài một element được tham chiếu (ref).
 * @param {React.RefObject} ref - Ref của element cần theo dõi.
 * @param {Function} handler - Hàm sẽ được gọi khi click ra ngoài.
 */
export function useOnClickOutside(ref, handler) {
    useEffect(() => {
        const listener = (event) => {
            // Nếu click vào bên trong ref hoặc ref chưa tồn tại, không làm gì cả
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };

        // Thêm event listener
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        // Dọn dẹp event listener khi component unmount
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
}